import { render, staticRenderFns } from "./ManufacturersPage.vue?vue&type=template&id=53cf72ec&scoped=true&"
import script from "./ManufacturersPage.vue?vue&type=script&lang=js&"
export * from "./ManufacturersPage.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturersPage.vue?vue&type=style&index=0&id=53cf72ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cf72ec",
  null
  
)

export default component.exports